import { useMemo } from 'react'
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate } from 'react-router-dom'
import Loader from './Loader'
import { useLanguage } from '../i18n/LanguageContext'

const Garage = ({ garageData, loadFigure }) => {
  const { lang, t } = useLanguage()
  const navigate = useNavigate()
  const garageJsonData = require("../data/garages.json");
  const validGarageNames = Object.keys(garageJsonData["maps-data"]);

  let { id } = useParams();
  id = id.toLowerCase();

  const garageName = id;

  const isValid = validGarageNames.includes(garageName);

  let data = null;
  if (isValid && garageData.length > 0) {
    data = garageData.find(g => g.properties.naam.toLowerCase() === garageName) ?? null;
  }

  const vrijePlekken = data?.properties.capaciteit_vrij == null ? "N/A" : data?.properties.capaciteit_vrij === 0 ? t('full') : data?.properties.capaciteit_vrij;
  const getTime = (iso) => new Date(iso).toLocaleTimeString('nl-NL', { timeZone: 'Europe/Amsterdam', hour: '2-digit', minute: '2-digit' });
  const tijdDisplay = data?.properties.lastFetched ? getTime(data.properties.lastFetched) : "--:--";
  const metaDesc = t('metaGarageDesc').replace(/\{name\}/g, garageName)

  const badgeColor = useMemo(() => {
    const vrij = data?.properties.capaciteit_vrij
    if (vrij == null || vrij === 0) return '#FF6B6B'
    if (vrij < 20) return '#FF6B6B'
    if (vrij < 50) return '#FFD93D'
    return '#6BCB77'
  }, [data?.properties.capaciteit_vrij])

  if (!isValid) {
    navigate("/pagina-niet-gevonden", { replace: true });
    return null;
  }

  if (garageData.length > 0 && !data && !loadFigure) {
    navigate("/pagina-niet-gevonden", { replace: true });
    return null;
  }

  return (
    <>
      <div className='garage'>
        <Helmet>
          <title>{t('metaGarageTitle')} {garageName}</title>
          <meta name='description' content={metaDesc} />
        </Helmet>

        {/* Hero Section - altijd tonen */}
        <div className="garage_hero">
          <img
            className="garage_hero_image"
            src={require("../img/" + garageName + ".webp")}
            alt={t('altGaragePhoto') + " " + garageName}
          />
          <div className="garage_hero_overlay"></div>
          <div className="garage_hero_content">
            <h1 className="garage_hero_title">{t('garageTitle')} {data?.properties.naam || garageName}</h1>
            <div className="garage_hero_badge" style={{ backgroundColor: loadFigure ? '#4285F4' : badgeColor }}>
              {loadFigure ? (
                <span className="skeleton-loader" style={{ width: '50px', height: '30px', display: 'inline-block', borderRadius: '4px' }}></span>
              ) : (
                <>
                  <span className="garage_hero_badge_number">{vrijePlekken}</span>
                  <span className="garage_hero_badge_label">{t('free')}</span>
                </>
              )}
            </div>
            <p className="garage_hero_updated">{t('updatedAt')} {loadFigure ? '--:--' : tijdDisplay} {t('hour')}</p>
          </div>
        </div>

        {/* Info Section - Loader of inhoud */}
        {loadFigure ? <div className="garage-loader"><Loader /></div> :
          <div className="garage_info_section">
            <div className="garage_info_grid">

              {/* Details Card */}
              <div className="garage_card">
                <h3 className="garage_card_title">{t('info')}</h3>
                <div className="garage_card_body">
                  <div className="garage_detail_row">
                    <span className="garage_detail_label">{t('address')}</span>
                    <span className="garage_detail_value">{data.properties.adres}</span>
                  </div>
                  <div className="garage_detail_row">
                    <span className="garage_detail_label">{t('clearance')}</span>
                    <span className="garage_detail_value">{data.properties.doorrijhoogte_m} m</span>
                  </div>
                  <div className="garage_detail_row">
                    <span className="garage_detail_label">{t('spots')}</span>
                    <span className="garage_detail_value">{vrijePlekken} {t('freeOf')} {data.properties.capaciteit_actueel} {t('free')}</span>
                  </div>
                  <div className="garage_detail_row">
                    <span className="garage_detail_label">{t('lastUpdated')}</span>
                    <span className="garage_detail_value">{tijdDisplay} {t('hour')}</span>
                  </div>
                  <a
                    className="garage_route_button"
                    href={garageJsonData["maps-data"][garageName]["route"]}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('routeTo')} {garageName}
                  </a>
                </div>
              </div>

              {/* Maps Card */}
              <div className="garage_card garage_card--map">
                <iframe
                  title={garageName}
                  className="garage_maps"
                  src={garageJsonData["maps-data"][garageName]["maps"]}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              {/* Description Card */}
              <div className="garage_card garage_card--description">
                <h3 className="garage_card_title">{t('garageInfo')}</h3>
                <div className="garage_card_body">
                  <p>{garageJsonData["maps-data"][garageName]["description_" + lang]}</p>
                </div>
              </div>

            </div>
          </div>
        }
      </div>
    </>
  )
}

export default Garage
